import { render, staticRenderFns } from "./CarrierArea.vue?vue&type=template&id=0d5f2622&scoped=true&"
import script from "./CarrierArea.vue?vue&type=script&lang=js&"
export * from "./CarrierArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5f2622",
  null
  
)

export default component.exports